import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ProfileDetailProfile } from './ProfileDetailProfile';
import { ProfileProvider } from '../../../ProfileContext';
import StyledFormTitle from '../../../styles/form-title';

const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;

export const ProfileDetail = () => {
    console.log('ProfileDetail');
    const { t } = useTranslation(['portal', 'create_edit_class']);

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Title>{t('portal:profile.title')}</Title>
                </Grid>
            </Grid>

            <ProfileProvider profileId={''}>
                <ProfileDetailProfile />
            </ProfileProvider>
        </>
    );
};
